module.exports = "/images/content-img-4.jpg?d77697ba50728dc3b32c0d2d43ef725e";